import { Controller } from "@hotwired/stimulus"
import * as basicLightbox from 'basiclightbox'
import "basiclightbox/dist/basicLightbox.min.css"

// Connects to data-controller="lightbox"
export default class extends Controller {
  static targets = ['item']

  connect() {
    this.instance = basicLightbox.create(this.itemTarget)
  }

  show() {
    this.instance.show()
  }
}
